import { Hub, IConnection } from "@gp/hub";
import { UserHubOptions } from "./UserHubOptions";
import { Observable } from "rxjs";
import { ArgumentNullError } from "@gp/utility";
import {
	UserHubSubscribeRequest,
	UserNotificationEnvelope,
	UserHubNotificationResponse,
} from "@api-types/user-hub/UserHubTypes";

export class UserHub extends Hub {
	constructor(options: UserHubOptions, connection: IConnection) {
		super(options, connection);
		this.initialize();
	}

	getSubscription(
		request: UserHubSubscribeRequest
	): Observable<UserNotificationEnvelope[]> {
		if (request == null) {
			throw new ArgumentNullError("request");
		}

		return this.createSubscription<UserNotificationEnvelope[]>(
			request.subscriptionId,
			() => this.invoke("Subscribe", request)
		);
	}

	async sendNotificationResponse(
		response: UserHubNotificationResponse
	): Promise<void> {
		if (response == null) {
			throw new ArgumentNullError("response");
		}

		return this.invoke("NotificationResponse", response);
	}
}
